import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { foodPageData, consumerGoodsFAQs } from "./foodFacilities";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForFood() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <>
      <BazAIHelmet
        title="AI-Powered Procurement for Consumer Goods Companies"
        description="EkkBaz AI helps consumer goods companies save 25% on procurement costs, automate demand forecasting, optimise inventory, and eliminate 2.5 hours of manual procurement work daily."
        keywords="consumer goods procurement software, FMCG supply chain AI, demand forecasting consumer goods, inventory optimization FMCG, supplier management consumer goods, procurement automation"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/industry/c-goods`}
        industryName="Consumer Goods"
        faqItems={consumerGoodsFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Consumer Goods"
        subtitle="Save 25% on procurement costs, eliminate 2.5 hours of daily manual work, and prevent stockouts with AI-powered demand forecasting."
        from="food"
      />
      <EnhancedPageLayout {...foodPageData} />
      <UpdateFooter />
    </>
  );
}
